/* eslint-disable */
import React from "react";
import "./StatusTile.css";

const StatusTile = ({ title, value }) => {
  const getDotColors = (val) => {
    if (val === "NA" || val === null || val === undefined) {
      return ["#c9c9c9", "#c9c9c9", "#c9c9c9"];
    }

    const num = Number(val);

    if (num >= 90) return ["green", "", ""];
    if (num >= 80) return ["", "#f1c40f", ""];
    return ["", "", "#e74c3c"];
  };

  const dotColors = getDotColors(value);

  return (
    <div className="status-tile-container">
      <p className="status-title">{title}</p>

      <div className="status-box">
        <span className="status-value">
          {value === "NA" ? "NA" : `${value}%`}
        </span>

        <div className="status-dots">
          {dotColors.map((color, index) => (
            <div
              key={index}
              className="dot"
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatusTile;
